/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
// import {Link} from 'react-router-dom'
import {useFormik} from 'formik'
// import {getUserByToken, login} from '../core/_requests'
// import {toAbsoluteUrl} from '../../../../_metronic/helpers'
// import {useAuth} from '../core/Auth'
import {useMutation} from '@apollo/client'
import {LOGIN} from '../../../graphql/mutations/loginMutation'
import {IUserLogin} from '../../../graphql/types/loginTypes'
import {useGetUser} from '../../../hooks/useGetUser'
import {Alert} from 'react-bootstrap'
import {VERION_APP} from '../../../helpers/consts'

const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Ingrese un correo electrónico válido')
    .min(3, 'Minimo 3 letras')
    .max(50, 'Máximo 50 letras')
    .required('Correo electrónico es obligatorio'),
  password: Yup.string()
    .min(3, 'Minimum 3 caracteres')
    .max(50, 'Maximum 50 symbols')
    .required('Contraseña es obligatoria'),
})

const initialValues = {
  email: '',
  password: '',
}

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  const [gqlLogin, {data, loading, error}] = useMutation<IUserLogin>(LOGIN)
  const {login} = useGetUser()

  const [show, setShow] = useState(false)
  // const [loading, setLoading] = useState(false)
  // const {saveAuth, setCurrentUser} = useAuth()

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async ({email, password}) => {
      gqlLogin({
        variables: {
          email,
          password,
        },
      })
    },
  })

  useEffect(() => {
    if (data) {
      login(data)
    }
  }, [data, login])

  const handleClick = () => setShow(!show)

  return (
    <form
      className='form w-100'
      onSubmit={formik.handleSubmit}
      noValidate
      id='kt_login_signin_form'
    >
      {/* begin::Heading */}
      <div className='text-center mb-11'>
        <h1 className='text-dark fw-bolder mb-3'>Iniciar sesión</h1>
        {/* <div className='text-gray-500 fw-semibold fs-6'>Con redes sociales</div> */}
      </div>
      {/* begin::Heading */}

      {/* begin::Login options */}
      {/* <div className='row g-3 mb-9'>
        <div className='col-md-6'>
          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/google-icon.svg')}
              className='h-15px me-3'
            />
            Sign in with Google
          </a>
        </div>
        <div className='col-md-6'>
          <a
            href='#'
            className='btn btn-flex btn-outline btn-text-gray-700 btn-active-color-primary bg-state-light flex-center text-nowrap w-100'
          >
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black.svg')}
              className='theme-light-show h-15px me-3'
            />
            <img
              alt='Logo'
              src={toAbsoluteUrl('/media/svg/brand-logos/apple-black-dark.svg')}
              className='theme-dark-show h-15px me-3'
            />
            Sign in with Apple
          </a>
        </div>
      </div> */}
      {/* end::Login options */}
      <div>{error && <Alert color='danger'>{error.message}</Alert>}</div>

      {/* begin::Separator */}
      <div className='separator separator-content my-14'>
        <span className='w-125px text-gray-500 fw-semibold fs-7'>Con correo</span>
      </div>
      {/* end::Separator */}

      {/* begin::Form group */}
      <div className='fv-row mb-4'>
        <label className='form-label fs-6 fw-bolder text-dark'>Email</label>
        <input
          placeholder='correo@correo.com'
          {...formik.getFieldProps('email')}
          className={clsx(
            'form-control bg-transparent',
            {'is-invalid': formik.touched.email && formik.errors.email},
            {
              'is-valid': formik.touched.email && !formik.errors.email,
            }
          )}
          type='email'
          name='email'
        />
        {formik.touched.email && formik.errors.email && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.email}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Form group */}
      <div className='fv-row mb-8 position-relative'>
        <label className='form-label fw-bolder text-dark fs-6'>Contraseña</label>
        <input
          type={show ? 'text' : 'password'}
          placeholder='Ingrese contraseña'
          autoComplete='off'
          {...formik.getFieldProps('password')}
          className={clsx(
            'form-control bg-transparent',
            {
              'is-invalid': formik.touched.password && formik.errors.password,
            },
            {
              'is-valid': formik.touched.password && !formik.errors.password,
            }
          )}
        />
        <div
          className='position-absolute'
          style={{
            bottom: formik.touched.password && formik.errors.password ? '37%' : '16%',
            right: formik.touched.password ? '10%' : '4%',
            zIndex: 10,
          }}
        >
          <button type='button' className='border-0 p-0 m-0 bg-transparent' onClick={handleClick}>
            {show ? (
              <i className='bi bi-eye-slash-fill fs-4 text-dark' />
            ) : (
              <i className='bi bi-eye-fill fs-4 text-primary' />
            )}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <div className='fv-plugins-message-container'>
            <div className='fv-help-block'>
              <span role='alert'>{formik.errors.password}</span>
            </div>
          </div>
        )}
      </div>
      {/* end::Form group */}

      {/* begin::Wrapper */}
      {/* <div className='d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-8'>
        <div />

        <Link to='/auth/forgot-password' className='link-primary'>
          Forgot Password ?
        </Link>
      </div> */}
      {/* end::Wrapper */}

      {/* begin::Action */}
      <div className='d-grid mb-10'>
        <button
          type='submit'
          id='kt_sign_in_submit'
          className='btn btn-primary'
          disabled={formik.isSubmitting || !formik.isValid || loading}
        >
          {!loading && <span className='indicator-label'>Ingresar</span>}
          {loading && (
            <span className='indicator-progress' style={{display: 'block'}}>
              Validando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
      {/* end::Action */}

      <div className='text-gray-500 text-center fw-semibold fs-6'>{VERION_APP}</div>
    </form>
  )
}
